module.exports = __webpack_public_path__ + "img/roots-white.6a2d1631.svg";